import { useState } from 'react'
import { useTranslation } from 'react-i18next'

interface Data {
  devices: {
    device: string
    visitors: number
  }[]
  os: {
    os: string
    visitors: number
  }[]
  browsers: {
    browser: string
    visitors: number
  }[]
}

interface Props {
  data: Data
}

export default function TopDevices({ data }: Props) {
  const { t } = useTranslation()
  const [active, setActive] = useState('devices')
  return (
    <div className="mb-10">
      <h3 className="mb-4 flex justify-between text-xl font-bold">
        {t('Top Devices')}
        <div className="flex justify-between">
          <span
            className={`ml-2 cursor-pointer text-sm ${active === 'devices' ? 'text-blue-500' : ''}`}
            onClick={() => setActive('devices')}
          >
            {t('Devices')}
          </span>
          <span
            className={`ml-2 cursor-pointer text-sm ${active === 'browsers' ? 'text-blue-500' : ''}`}
            onClick={() => setActive('browsers')}
          >
            {t('Browsers')}
          </span>
          <span
            className={`ml-2 cursor-pointer text-sm ${active === 'os' ? 'text-blue-500' : ''}`}
            onClick={() => setActive('os')}
          >
            {t('OS')}
          </span>
        </div>
      </h3>
      {active === 'devices' && (
        <div>
          <p className="flex w-full justify-between text-sm">
            <span>{t('Device')}</span>
            <span>{t('Visitors')}</span>
          </p>
          {data.devices?.map((device, index) => (
            <div
              key={index}
              className="mb-4 flex justify-between border-b pb-2"
            >
              <div>{device.device}</div>
              <div className="font-bold">{device.visitors}</div>
            </div>
          ))}
        </div>
      )}
      {active === 'browsers' && (
        <div>
          <p className="flex w-full justify-between text-sm">
            <span>{t('Browser')}</span>
            <span>{t('Visitors')}</span>
          </p>
          {data.browsers?.map((browser, index) => (
            <div
              key={index}
              className="mb-4 flex justify-between border-b pb-2"
            >
              <div>{browser.browser}</div>
              <div className="font-bold">{browser.visitors}</div>
            </div>
          ))}
        </div>
      )}
      {active === 'os' && (
        <div>
          <p className="flex w-full justify-between text-sm">
            <span>{t('OS')}</span>
            <span>{t('Visitors')}</span>
          </p>
          {data.os?.map((os, index) => (
            <div
              key={index}
              className="mb-4 flex justify-between border-b pb-2"
            >
              <div>{os.os}</div>
              <div className="font-bold">{os.visitors}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
